#import "../NoteFields.graphql"

mutation createUsDueDiligenceNote($usDueDiligenceId: ID!, $content: String!) {
  createUsDueDiligenceNote(
    input: { usDueDiligenceId: $usDueDiligenceId, content: $content }
  ) {
    usDueDiligenceNote {
      ...NoteFields
    }
  }
}
